module.exports = __webpack_public_path__ + "img/05.2f1a2aa6.png";